/** Polling while the POS / card-on-file confirmation popup is shown (user is waiting). */
export const PAYMENT_CONFIRMATION_POLL_INTERVAL_MS = 10000;
/** ~5 min window at 10s intervals; POS also uses a separate 2-minute deadline. */
export const PAYMENT_CONFIRMATION_MAX_POLL_COUNT = 30;

/** Polling on the payment status timeline sidebar (longer multi-step flow). */
export const PAYMENT_TIMELINE_POLL_INTERVAL_MS = 20000;
/** ~5 min window at 20s intervals. */
export const PAYMENT_TIMELINE_MAX_POLL_COUNT = 15;
